import { gql, useQuery } from '@apollo/client'
import { usePermissions } from 'react-admin'
import { nhost } from '~/helpers'

/**
 * Two-factor sign-in (TOTP) as the CMS sees it: whether the signed-in user has
 * it, and whether app_settings makes it mandatory for admins. Turning it on and
 * off is nhost/auth's (`/mfa/totp/generate`, `/user/mfa`); once on, nhost/auth
 * itself refuses a session without the code.
 */
export const TWO_FACTOR = gql`
  query TwoFactor($id: uuid!) {
    me: user(id: $id) {
      id
      activeMfaType
    }
    settings: app_settings_by_pk(id: 1) {
      require_admin_mfa
    }
  }
`

export const TEAM = gql`
  query TwoFactorTeam {
    users(where: { disabled: { _eq: false } }, order_by: [{ displayName: asc }, { email: asc }]) {
      id
      displayName
      email
      activeMfaType
    }
  }
`

export const SET_REQUIRED = gql`
  mutation RequireAdminMfa($on: Boolean!) {
    update_app_settings_by_pk(pk_columns: { id: 1 }, _set: { require_admin_mfa: $on }) {
      id
      require_admin_mfa
    }
  }
`

export const RESET = gql`
  mutation ResetMfa($id: uuid!) {
    crm_reset_mfa(args: { user_id: $id }) {
      id
      activeMfaType
    }
  }
`

export const useTwoFactor = () => {
  const id = nhost.getUserSession()?.user?.id
  const { permissions } = usePermissions()
  const { data, refetch } = useQuery(TWO_FACTOR, {
    variables: { id },
    skip: !id,
    fetchPolicy: 'cache-and-network',
  })
  return {
    loaded: !!data,
    active: !!data?.me?.activeMfaType,
    required: !!data?.settings?.require_admin_mfa,
    isAdmin: ((permissions as string[] | undefined) ?? []).includes('admin'),
    refetch,
  }
}

/** "JBSW Y3DP EHPK 3PXP" — easier to type into an app by hand. */
export const groupKey = (secret: string) => secret.replace(/(.{4})(?=.)/g, '$1 ')
